import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useClientSavePepConnectionMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { SavePepConnectionParam } from 'api/types/params';

import { parseClientEntity, parseClientPepConnectionParam } from '../helpers';

export const useClientSavePepConnection = () => {
  const [savePepConnection, { data, loading, error: apolloError }] =
    useClientSavePepConnectionMutation();

  const error = useError(apolloError);

  return {
    data: data?.clientSavePepConnection
      ? parseClientEntity(data.clientSavePepConnection)
      : undefined,
    loading,
    error,
    savePepConnection: useCallback(
      async (id: string, params: SavePepConnectionParam) => {
        const res = await savePepConnection({
          variables: {
            id,
            input: parseClientPepConnectionParam(params),
          },
        });
        return res.data?.clientSavePepConnection
          ? parseClientEntity(res.data.clientSavePepConnection)
          : undefined;
      },
      [savePepConnection]
    ),
  };
};
